// extracted by mini-css-extract-plugin
module.exports = {"socials_wrapper":"socials_socials_wrapper__0wXWS","socials_container":"socials_socials_container__sPsJK"};